import { render, staticRenderFns } from "./panziStarterNavbar.vue?vue&type=template&id=7c9d8631&scoped=true&"
import script from "./panziStarterNavbar.vue?vue&type=script&lang=js&"
export * from "./panziStarterNavbar.vue?vue&type=script&lang=js&"
import style0 from "./panziStarterNavbar.vue?vue&type=style&index=0&id=7c9d8631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9d8631",
  null
  
)

export default component.exports